<script>
import Service from '../../services/jetty';
import VesselProtocolService from '../../services/vessel-protocol';

import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';

import GenericCustomMasterDataAutocompleteV2 from '../../components/generic/GenericCustomMasterDataAutocompleteV2.vue'

export default{
  components: {
    GenericCustomMasterDataAutocompleteV2,
},
  data(){
    return {
      loading: false,
      filter: {
        idMovementInstructionHeader: null,
        total: 0
      },
      data: [],
      params: {
      },
      onlyOpened: true,
      attachmentsDialogVisible: false,
      attachmentsLoading: false,
      attachments: []
    }
  },
  computed: {
    constants(){
        return CommonConstants;
    },
    utils(){
      return Utils;
    },
    uiPermissions(){
      return this.$store.getters['security/uiPermissions'];
    }
  },
  created(){
    
  },
  mounted(){
    this.$store.dispatch('security/setNavbarTitle', 'JettyUllage.page_title');
  },
  watch: {
    onlyOpened(){
      this.$refs.voyagesCombo.forceLoadOptions("movement-instruction/voyage-number-combo?transportType=N,B&onlyOpened=" + this.onlyOpened)
    }
  },
  methods: {
    loadData(){
      this.loading = true;
      Service.getUllageHeaders(this.filter.idMovementInstructionHeader, response => {
        
          this.loading = false;
          if(response.success){
              this.data = response.data;
              this.total = response.totalCount;
          }
      });
    },
    onVoyageSelected(){
      this.loadData();
    },
    formatDecimal(n, digits){
        if(!digits){
            digits = 2;
        }
        return n ? n.toLocaleString(undefined, {minimumFractionDigits: digits, maximumFractionDigits: digits}) : 0;
    },
    formatProducts(items){
        return items.map(function (e) {
          return e.gradeName;
        }).join(', ')
    },
    openDetails(data){
      let uri = `/jetty/ullage/${data.id}`;
      this.$router.push(uri);
    },
    openAttachments(data){
      this.attachments = [];
      this.attachmentsDialogVisible = true;
      this.attachmentsLoading = true;
      Service.getUllageDocuments(data.id, response => {
          this.attachmentsLoading = false;
          if(response.success){
              this.attachments = response.data;
          }
      });
    },
    downloadDocument({documentGuid, fileName, fileExtension}){
      this.$store.dispatch("generic/setLoading", true);
      let fileNameWithExtension = fileName + fileExtension;
      VesselProtocolService.downloadDocumentVesselProtocol({documentGuid: documentGuid, fileNameWithExtension }, ({success, data, message}) => {
        this.$store.dispatch("generic/setLoading", false);
        
        if(success){
          var fileURL = window.URL.createObjectURL(new Blob([data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', fileNameWithExtension);
          document.body.appendChild(fileLink);
      
          fileLink.click();
        } else{
          this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
        }
      })
    },
  }
}

</script>

<template>
  <main>
    <div class="m-5">
      <div class="grid">
        <div class="col-12 lg:col-4 field">
          <label for="voyages">{{$t('timesheet.voyage')}}</label>
          <GenericCustomMasterDataAutocompleteV2
            ref="voyagesCombo"
            :changeFn="onVoyageSelected"
            v-model="filter.idMovementInstructionHeader"
            :queryField="{getOnlyOpened: onlyOpened, transportType: 'N,B'}"
            name="voyages-combo-for-eta" 
            id="voyages"
            api="movement-instruction/voyage-number-combo?onlyOpened=true&transportType=N,B"
            class="w-full p-inputtext-sm" />
            <div>
              <Checkbox
              v-model="onlyOpened" 
              :binary="true" 
              name="onlyOpened"
              class="mt-2 mr-2"/>
              <label for="onlyOpened">{{$t('timesheet.onlyOpenedVoyage')}}</label>  
            </div>
        </div>
        <div class="col-12">
          <DataTable style="height: 26vw" :loading="loading" :reorderableColumns="true"
            :value="data" :lazy="true" showGridlines stripedRows  ref="dt" :resizableColumns="true" columnResizeMode="expand">
               <Column :exportable="false" :reorderableColumn="false" >
                <template #body="slotProps"> 
                    <Button icon="pi pi-eye" class="p-button-rounded p-button-success mr-2" v-tooltip="$t('btn.view')" @click="openDetails(slotProps.data)"/>
                    <Button icon="pi pi-download" class="p-button-rounded p-button-success mr-2" v-tooltip="$t('btn.attachments')" @click="openAttachments(slotProps.data)"/>
                </template>
              </Column>
              <Column :header="$t('JettyUllage.voyageNumber')"
                  field="voyageNumber">
                  <template #body="element">
                      {{element.data.voyageNumber}}
                  </template>
              </Column>
              <Column :header="$t('JettyUllage.type')"
                  field="isObqRob">
                  <template #body="element">
                      {{element.data.isObqRob ? 'OBQ/ROB': 'Ullage'}}
                  </template>
              </Column>
              <Column :header="$t('JettyUllage.registryVessel')"
                  field="registryVessel" >
                  <template #body="element">
                      {{element.data.registryVessel}}
                  </template>
              </Column>
              <Column :header="$t('JettyUllage.ullageDate')"
                  field="ullageDate" dataType="date">
                  <template #body="element">
                      {{element.data.ullageDate != null ? utils.formatDate(utils.dateToCurrentTimeZone(element.data.ullageDate)) : null}}
                  </template>
              </Column>
              <Column :header="$t('JettyUllage.from')"
                  field="voyageFrom" >
                  <template #body="element">
                      {{element.data.voyageFrom}}
                  </template>
              </Column>
              <Column :header="$t('JettyUllage.to')"
                  field="voyageTo" >
                  <template #body="element">
                      {{element.data.voyageTo}}
                  </template>
              </Column>
              <Column :header="$t('JettyUllage.berthNumber')"
                  field="berthNumber" >
                  <template #body="element">
                      {{element.data.berthNumber}}
                  </template>
              </Column>
              <Column :header="$t('JettyUllage.draftFore')"
                  field="draftFore" >
                  <template #body="element">
                       {{formatDecimal(element.data.draftFore, 2)}}
                  </template>
              </Column>
              <Column :header="$t('JettyUllage.draftAfter')"
                  field="draftAfter" >
                  <template #body="element">
                       {{formatDecimal(element.data.draftAfter, 2)}}
                  </template>
              </Column>
              <Column :header="$t('JettyUllage.draftTrim')"
                  field="draftTrim" >
                  <template #body="element">
                       {{formatDecimal(element.data.draftTrim, 2)}}
                  </template>
              </Column>
              <Column :header="$t('JettyUllage.list')"
                  field="list" >
                  <template #body="element">
                       {{formatDecimal(element.data.list, 2)}}
                  </template>
              </Column>
              <Column :header="$t('JettyUllage.products')"
                  field="ullageVoyageProducts" >
                  <template #body="element">
                       {{formatProducts(element.data.ullageVoyageProducts)}}
                  </template>
              </Column>
              <Column :header="$t('user_roles.user')"
                  field="createdBy" >
                  <template #body="element">
                       {{element.data.createdBy}}
                  </template>
              </Column>
              <Column :header="$t('JettyUllage.insertDate')"
                  field="insertDate" dataType="date">
                  <template #body="element">
                      {{element.data.insertDate != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(element.data.insertDate)) : null}}
                  </template>
              </Column>
              <template #empty>
                  {{$t('noRecordsFound')}}
              </template>
            </DataTable>

            <Dialog v-model:visible="attachmentsDialogVisible" :style="{width: '450px'}" :modal="true" class="p-fluid">
            <DataTable style="height: 26vw" :reorderableColumns="true"
            :value="attachments" :lazy="true" showGridlines stripedRows  ref="dt" :resizableColumns="true" columnResizeMode="expand">
               <Column :exportable="false" :reorderableColumn="false" >
                <template #body="slotProps">
                    <Button icon="pi pi-download" class="p-button-rounded p-button-success mr-2" v-tooltip="$t('btn.download')" @click="downloadDocument(slotProps.data)"/>
                </template>
              </Column>
              <Column :header="$t('JettyUllage.documentDescription')"
                  field="description">
                  <template #body="element">
                      {{element.data.description}}
                  </template>
              </Column>
              <Column :header="$t('user_roles.user')"
                  field="createdBy" >
                  <template #body="element">
                       {{element.data.createdBy}}
                  </template>
              </Column>
              <Column :header="$t('JettyUllage.documentDate')"
                  field="documentDate" dataType="date">
                  <template #body="element">
                      {{element.data.documentDate != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(element.data.documentDate)) : null}}
                  </template>
              </Column>
              <template #empty>
                  {{$t('noRecordsFound')}}
              </template>
            </DataTable>
            </Dialog>

        </div>
      </div>
    </div>
  </main>
</template>